import Lang from "../../common/lang/Lang";

export const urls = {
  home: "/systemInfo/",
  list: "/systemInfo/notification",
}

export const ListBreadcrumb = [
  {
    label: Lang.system_info,
    url: urls.home
  },
  {
    label: Lang.notification,
    url: "#"
  }
];

